import React from 'react';

import {
  Redirect,
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import Dashboard from '../templates/Dashboard';

interface RouteProps extends ReactDOMRouteProps {
  component: React.ComponentType;
  isPrivate?: boolean;
}

const Route: React.FC<RouteProps> = ({
  component: Component,
  isPrivate = false,
  ...rest
}) => {
  const { user } = useAuth();

  if (isPrivate) {
    return (
      <ReactDOMRoute
        {...rest}
        render={({ location }) => {
          return user ? (
            <Dashboard>
              <Component />
            </Dashboard>
          ) : (
            <Redirect
              to={{
                pathname: isPrivate ? '/' : '/dashboard',
                state: location,
              }}
            />
          );
        }}
      />
    );
  }

  return <ReactDOMRoute {...rest} render={() => <Component />} />;
};

export default Route;
